import InsertLinkOutlinedIcon from '@mui/icons-material/InsertLinkOutlined';
import QrCode2OutlinedIcon from '@mui/icons-material/QrCode2Outlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import Button from '@mui/material/Button';
import Switch from '@mui/material/Switch';
import clsx from 'clsx';
import QRCode from 'qrcode';
import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { BACKEND_URL } from 'src/constants';
import { ENoticeType } from 'src/enums';
import { isObjectEmpty } from 'src/helpers';
import { setNotice } from 'src/redux/noticesSlice';
import { ICards, useGetCardQuery, useUpdateCardMutation } from 'src/redux/services/cards';
import { CustomTypography } from '../custom/CustomTypography';
import { ModalInfo } from '../modal/ModalInfo';
import { InputField } from './../shared/InputBlock';
import styles from './CardBlock.module.css';

/**
 * Блок Визитка
 */

export const CardBlock = ({ userId }: { userId?: string }) => {
  const dispatch = useDispatch();

  const [isOpen, setIsOpen] = useState(false);
  const [qrcode, setQrcode] = useState<string>('');
  const { data } = useGetCardQuery(userId || '', {
    skip: !userId,
  });
  const [updateCard] = useUpdateCardMutation();

  const methods = useForm<ICards>({
    defaultValues: data,
  });
  const {
    handleSubmit,
    register,
    formState: { dirtyFields },
    reset,
    watch,
  } = methods;

  useEffect(() => {
    reset(data);
  }, [data]);

  const onSubmit = async (data: ICards) => {
    try {
      await updateCard({ userId: userId || '', data }).unwrap();
    } catch (error) {
      console.error(error);
    }
  };

  const openQrcodeModal = async () => {
    const qrcode = await QRCode.toDataURL(BACKEND_URL + '/api/cards/' + (data?.card_url || userId));
    setQrcode(qrcode);
    setIsOpen(true);
  };

  const openCard = async () => {
    const cardUrl = BACKEND_URL + '/api/cards/' + (data?.card_url || userId);
    window.open(cardUrl, '_blank');
  };

  const handleCopy = async () => {
    navigator.clipboard.writeText(BACKEND_URL + '/api/cards/' + (data?.card_url || userId));
    dispatch(
      setNotice({
        type: ENoticeType.info,
        id: Math.random(),
        isRead: false,
        message: 'Ссылка скопирована',
        timestamp: new Date().toString(),
      }),
    );
  };

  return (
    <div className={styles.panel} style={{ paddingBottom: 22 }}>
      <div style={{ paddingTop: 22 }}>
        <div style={{ paddingBottom: 22 }}>
          <CustomTypography className={clsx('header-3', 'font-golos')}>Визитка</CustomTypography>
        </div>
        <FormProvider {...methods}>
          <form>
            <div className={styles.switcher}>
              <div>
                <CustomTypography className="text-14">Активность</CustomTypography>
                <CustomTypography className={clsx('text-12')} color="grey">
                  Если отключить, то визитка не будет доступна для просмотра
                </CustomTypography>
              </div>
              <Switch checked={watch('card_active') ?? false} {...register('card_active')} />
            </div>
            <InputField
              name={'card_url'}
              label="Идентификатор визитки (slug)"
              subtitle="https://example.com/slug"
            />
            <div className={styles.buttonsContainer}>
              <Button
                className={styles.button}
                onClick={() => openCard()}
                variant="custom"
                disabled={!watch('card_active')}
                startIcon={<VisibilityOutlinedIcon />}
              />
              <Button
                className={styles.button}
                onClick={() => openQrcodeModal()}
                variant="custom"
                disabled={!watch('card_active')}
                startIcon={<QrCode2OutlinedIcon />}
              />
              <Button
                className={styles.button}
                onClick={handleCopy}
                variant="custom"
                disabled={!watch('card_active')}
                startIcon={<InsertLinkOutlinedIcon />}
              />
              <Button
                className={styles.button}
                onClick={handleSubmit(onSubmit)}
                disabled={isObjectEmpty(dirtyFields)}
                variant="custom"
                type="submit"
              >
                Сохранить
              </Button>
            </div>
          </form>
        </FormProvider>

        <ModalInfo isOpen={isOpen} onClose={() => setIsOpen(false)}>
          <img className={styles.qrcodeImage} src={qrcode} />
        </ModalInfo>
      </div>
    </div>
  );
};
